/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getVideoPlaylist.defs.js";
export { main as default } from "./getVideoPlaylist.defs.js";
